import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Permissions';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of permission',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/permissions',
		},
	],
};

export default function EditPermission() {
	const [loader, setLoader] = useState(false),
		{ id } = useParams(),
		[errors, setErrors] = useState({}),
		[data, setData] = useState({}),
		[type, setType] = useState(),
		[method, setMethod] = useState(),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		types = [
			{
				value: 'public',
				label: 'Public',
			},
			{
				value: 'private',
				label: 'Private',
			},
		],
		methods = [
			{
				value: 'GET',
				label: 'Read all',
			},
			{
				value: 'POST',
				label: 'Create',
			},
			{
				value: 'PUT',
				label: 'Update',
			},
			{
				value: 'DELETE',
				label: 'Delete',
			},
			// {
			// 	value: 'activate_deactivate',
			// 	label: 'activate/deactivate',
			// },
			// {
			// 	value: 'top_up',
			// 	label: 'top up',
			// },
			{
				value: 'details',
				label: 'details',
			},
		];

	async function onGet() {
		setLoading(true);
		const response = await resources.permission
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (response.status === 200) {
			setData(response.data);
			const methodFilter = methods.filter((method) => {
				const isMethodOk = method.value === response.data?.method;
				const isUriOk = response.data?.uri.endsWith('/:id');
				return isUriOk && response.data?.method === 'GET'
					? method.label === 'Read one'
					: isMethodOk;
			});
			const typeFilter = types.filter(
				(type) => type.value === response.data?.type
			);
			setMethod(methodFilter[0]);
			setType(typeFilter[0]);
		} else if (response.status === 403) {
			setFail(true);
		}
		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (type) object.type = type.value;
		if (method) object.method = method.value;
		setLoader(true);
		setErrors({});
		let res = await resources.permission
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/permissions');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="title"
									className="mb-3"
									error={errors['title']}
									defaultValue={data.title}
									required
								>
									Permission Title
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permission Type{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setType(e)}
										options={types}
										value={type}
										isSearchable
										isClearable={false}
										className={
											errors['type'] ? ' is-invalid' : ''
										}
									/>
									{errors['type'] && (
										<div className="invalid-feedback">
											{errors['type']}
										</div>
									)}
								</div>

								<Field
									name="group"
									readOnly
									className="mb-3"
									error={errors['group']}
									defaultValue={data.group}
									required
								>
									Permission category
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Method of permission{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setMethod(e)}
										options={methods}
										value={method}
										isSearchable
										isClearable={false}
										className={
											errors['method']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['method'] && (
										<div className="invalid-feedback">
											{errors['method']}
										</div>
									)}
								</div>

								<Field
									name="uri"
									className="mb-3"
									error={errors['uri']}
									defaultValue={data.uri}
									required
								>
									Uri
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
